import axios from 'axios';

const axiosServices = axios.create();

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.response.use(
  (response) => response,
  (error) =>    Promise.reject(
    error instanceof Error
      ? error
      : new Error(
          error?.response?.data?.message ??
          error?.message ??
          'Wrong Services'
        )
  )

);

export default axiosServices;
